/* eslint-disable import/prefer-default-export */
import { toast } from 'react-toastify';
import Api from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';
import { isEscene } from '../lib/utils';

// get Port config template by port name i.e alarmObi/alarmEscene
export const getPortConfigTemplates = (token, dc, portType, ataType) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.getPortConfigTemplates(dc, portType, ataType);
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_SUCCESS',
      payload: data?.data || []
    })
    return data?.data || [];
  } catch (error) {
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_SUCCESS',
      payload: []
    })
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'getPortConfigTemplates',
    });
    return [];
  }
};

// get Port config template by port name i.e alarmObi/alarmEscene
export const getPortConfigTemplatesByPortName = (token, dc, macAddress, portType) => async dispatch => {
  const api = new Api(token);
  portType = isEscene(macAddress) ? `${portType}Escene` : `${portType}Obi`
  try {
    const data = await api.portConfig.getPortConfigTemplateByPortType(dc, portType);
    console.log("data from portconfigtemplate", data)
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'getPortConfigTemplatesByPortName',
    });
    return [];
  }
};

// set selected port config template in redux
export const setSelectedPortConfigTemplate = (selectedTemplate) => async dispatch => {
  dispatch({
    type: 'SELECTED_PORT_CONFIG_TEMPLATE_SUCCESS',
    payload: selectedTemplate
  })
};
